export const TAB_NAMES = {
    DEMO: "Demo",
    ABOUT: "About",
    INSTALL_AND_RUN: "Install And Run"
};


// WEBPACK FOOTER //
// ./src/components/model/TabPanel/TabNames.ts